export default __webpack_public_path__ + "static/media/1156.c03afeef.png";